import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useObserver } from 'mobx-react-lite';

import useUI from 'hooks/use-ui';
import useTranslation from 'hooks/use-translation';
import { Clickable } from 'shared/components';
import ChevronIcon from 'assets/chevron-icon';

// note, this function is duplicated line for line in api/src/env/endpoints/embedded-v3/embed-src/back-to-top.js
// any changes to this should be made there as well so that behavior is the same
export const createScrollHandler = (setVisible, offsetTop = 0) => {
  let prevScrollY = window.pageYOffset;
  let deadZoneScrollPos = window.pageYOffset;
  let wasScrollingUp = false;

  return () => {
    const newScroll = window.pageYOffset;
    let isScrollingUp = newScroll > offsetTop + 20 && newScroll < prevScrollY;
    prevScrollY = newScroll;
    if (isScrollingUp !== wasScrollingUp) {
      // scroll direction has changed, check the deadzone
      if (Math.abs(newScroll - deadZoneScrollPos) < 20) {
        isScrollingUp = wasScrollingUp;
      }
    } else {
      deadZoneScrollPos = newScroll;
    }
    if (isScrollingUp !== wasScrollingUp) {
      wasScrollingUp = isScrollingUp;
      setVisible(isScrollingUp);
    }
  };
};

export default function BackToTop() {
  const [visible, setVisible] = useState();
  const UI = useUI();
  const { t } = useTranslation();
  const isIframe = useObserver(() => UI.isIframe);

  useEffect(() => {
    const scrollHandler = createScrollHandler(setVisible);
    document.addEventListener('scroll', scrollHandler);
    return () => document.removeEventListener('scroll', scrollHandler);
  }, []);

  if (isIframe) {
    // back to top is handled by embed-src script in iframes
    return null;
  }

  function scrollToTop() {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
  }

  return (
    <Container
      aria-label={t('common.scroll_to_top', 'Scroll to top')}
      className={visible ? 'visible' : ''}
      onClick={scrollToTop}
    >
      <ChevronIcon />
    </Container>
  );
}

const Container = styled(Clickable)`
  width: 40px;
  height: 40px;
  border-radius: 7px;
  position: fixed;
  bottom: 19px;
  left: calc(50% - 20px);
  text-align: center;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;

  background-color: ${({ theme }) => theme.colors.primaryBlue};

  &.visible {
    opacity: 1;
    pointer-events: initial;
    cursor: pointer;
  }

  svg {
    position: relative;
    height: 8.5px;
    width: 14px;
    fill: white;
    transform: rotate(-180deg);
    margin-bottom: 1px;
  }
`;
